<section class="centered-with-padding pb-16 pt-6">
  @if (data.items; as items) {
    <ul class="relative mb-7 list-none">
      @for (item of items; track index; let index = $index) {
        <li
          #cardItem
          [ngClass]="{
            'top-[100px]': index === 0,
            'top-[230px]': index === 1,
            'top-[245px]': index === 2,
            'top-[260px]': index === 3,
            'top-[275px]': index === 4,
          }"
          class="sticky">
          <a [routerLink]="item.url">
            @if (data.title && index === 0) {
              <div class="pb-2.5 desk:w-1/2">
                <app-title [title]="data.title" size="h1" />
              </div>
            }
            <div
              [class.mt-48]="index !== 0"
              [class.mt-5]="index === 0"
              [ngClass]="{
                '-rotate-2': index === 0,
                'rotate-1': index === 1 || index === 4,
                '-rotate-1': index === 2,
                'rotate-2': index === 3,
              }"
              class="relative flex h-[400px] w-full items-center justify-center desk:h-[60svh]">
              <div class="drop-shadow-custom size-full overflow-hidden rounded-[40px] bg-white object-cover">
                <app-image
                  [image]="item.image"
                  [isPriority]="!isImageInPreviousBlocks && index < 2"
                  [pregenerationSize]="{ width: 1080, height: 600 }" />
                <div
                  aria-hidden="true"
                  class="pointer-events-none absolute inset-0 z-20 bg-gradient-to-t from-black/75 to-transparent bg-[length:100%_50%] bg-bottom bg-no-repeat"></div>
                <div
                  [style.opacity]="overlayOpacities()[index]"
                  aria-hidden="true"
                  class="pointer-events-none absolute inset-0 z-10 bg-white transition-opacity duration-300"></div>
              </div>
              <div class="absolute inset-x-0 bottom-0 z-30 flex justify-between p-6 text-white desk:p-11">
                <div class="flex flex-col align-bottom desk:gap-y-3">
                  <span class="font-title-alt text-[13px] desk:text-[18px]">{{ "GLOBAL.KITCHEN" | translate }}</span>
                  <span class="font-title text-[25px] desk:text-[47px]">
                    {{ item.name }}
                  </span>
                </div>
                <div class="flex flex-col justify-center gap-y-1 align-bottom desk:gap-y-4">
                  <span class="font-title text-[25px] desk:text-[47px]">{{ item.price }}</span>
                  @if (item.ecoPart) {
                    <span class="text-sm desk:text-[12px]">{{
                      "PRICE.ECO_PART" | translate: { ecoPart: item.ecoPart }
                    }}</span>
                  }
                </div>
              </div>
            </div>
          </a>
        </li>
      }
    </ul>
  }
  @if (data.cta; as cta) {
    <div class="flex justify-center">
      @let gtm = data.gtmConfigCta;
      <app-button
        (onButtonClick)="
          emitGtmEvent({
            event: gtm?.event,
            group: gtm?.group,
            description: gtm?.description,
            context: gtm?.context,
            button_text_value: cta.label,
            event_type: 'click',
          })
        "
        [label]="cta.label"
        [url]="cta.url" />
    </div>
  }
</section>
